export const filterConsts = {
  TITLE: "Filter",
  WIDTH: "30rem",
};

export const filterFieldConstants = {
  ADDRESS_NAME: "addressField",
  ADDRESS_LABEL: "Location",
  ADDRESS_PLACEHOLDER: "Search",
  RADIUS_NAME: "radiusField",
  RADIUS_LABEL: "Radius",
  RADIUS_ADDON: "miles",
  ADDRESS_DATA_FIELD: "addressData",
};

export const FILTER_FIELD_NAMES_TO_COUNT = ["address", "radius"] as const;
